import { Controller, useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { FormError } from "@/components/ui/form"
import { ScrollArea } from "@/components/ui/scroll-area"
import { LabelAndSelectValue, Select, SelectContent, SelectItem, SelectTrigger } from "@/components/ui/select"
import { BetterDocSearchBaseFormType } from "@/modules/patients/detail/better-doc/schema/better-doc-search-base-schema"
import { BetterDocConsultationReasonValues } from "@/types/__generated__/union-types"

export const BetterDocConsultationReasonSelect = () => {
  const { t } = useTranslation()
  const {
    control,
    formState: { errors },
  } = useFormContext<BetterDocSearchBaseFormType>()

  return (
    <div className="w-full">
      <Controller
        control={control}
        name="reasonForConsultations"
        render={({ field: { value, onChange } }) => {
          const selectedReason = BetterDocConsultationReasonValues.find((option) => option === value)

          return (
            <Select value={value} onValueChange={onChange}>
              <SelectTrigger
                data-testid="reason-for-consultation-select-trigger"
                hasError={!!errors.reasonForConsultations?.message}>
                <LabelAndSelectValue
                  required
                  label={t("episodeOfCare.betterDoc.searchDialog.reasonForConsultations.label")}
                  value={
                    selectedReason
                      ? t(`episodeOfCare.betterDoc.searchDialog.reasonForConsultations.${selectedReason}`)
                      : ""
                  }
                />
              </SelectTrigger>
              <SelectContent className="max-w-(--radix-select-trigger-width)">
                <ScrollArea className="max-h-64">
                  <div className="py-2">
                    {BetterDocConsultationReasonValues.map((option) => (
                      <SelectItem key={option} value={option} data-testid={`reason-for-consultation-option-${option}`}>
                        {t(`episodeOfCare.betterDoc.searchDialog.reasonForConsultations.${option}`)}
                      </SelectItem>
                    ))}
                  </div>
                </ScrollArea>
              </SelectContent>
            </Select>
          )
        }}
      />
      {errors.reasonForConsultations?.message && <FormError>{t(errors.reasonForConsultations.message)}</FormError>}
    </div>
  )
}
